<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>Features of PayG</h2>
                </div>
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="1">
                    <!-- <div style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/5kY7ApMM9Uo"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div> -->
                    <label for="" class="mt-4">PayG offers a variety of features and services to facilitate online transactions and enable businesses to accept payments securely and efficiently. Some common features of PayG include:</label>


                   <ol class="mt-4">
                    <li  class="mt-4"><b>Multiple Payment Options: &nbsp;</b>Payment gateways support various payment methods, including credit and debit cards, net banking, UPI, mobile wallets, and other digital payment options, allowing customers to pay using their preferred mode</li>
                    <li  class="mt-4"><b>Secure Transactions: &nbsp;</b>Payment gateways employ encryption and other security measures to ensure that sensitive customer information, such as card details, remains protected during the payment process.</li>
                    <li  class="mt-4"><b> Payment Support:&nbsp;</b>PayG offers payment support all over India, allowing businesses to accept payments from customers located in different states/UTs.</li>
                    <li  class="mt-4"><b>Real-Time Reporting and Analytics &nbsp;</b>Businesses can monitor their payment activity and track success thanks to dashboards provided by PayG that provide real-time transaction data, analytics, and insights.</li>
                    <li  class="mt-4"><b>Payment buttons Customization:  &nbsp;</b>PayG offers customization options for payment buttons, enabling businesses to match the branding and design elements of their websites for a seamless user experience.</li>
                    <li  class="mt-4"><b>Fraud Prevention and Risk Management:&nbsp;</b> To identify and mitigate fraudulent transactions, PayG uses fraud protection technologies and risk management systems, which lowers the likelihood of chargebacks and losses.</li>
                    <li  class="mt-4"><b> 24/7 Customer Support: &nbsp;</b>PayG offers round-the-clock customer support to assist businesses and customers with any payment-related issues or queries.</li>
                    <li  class="mt-4"><b>PCI Compliance:  &nbsp;</b>PayG adheres to Payment Card Industry Data Security Standard (PCI DSS) compliance, ensuring the highest level of data security for cardholder information.

                    </li>
                    <li  class="mt-4"><b>Instant Settlements:  &nbsp;</b>Businesses who use PayG's rapid settlement service can get money in their bank accounts right away following a successful transaction.

                    </li>
                    <li  class="mt-4"><b>Payment Routing: &nbsp;</b>PayG supports payment routing, which automatically routes transactions through different processors or acquirers to optimize payment success rates.</li>
                    <li  class="mt-4"><b>Virtual POS (Point of Sale): &nbsp;</b> Virtual POS terminals provided by PayG enable businesses to accept payments online, over the phone, or through other remote methods.

                    </li>
                    
                   </ol>
                </div>
               
            </div>
        </div>
    </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>
                </div>
               
                <div class="col-md-12">
                    <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'color':colors=='1'}"
                                    (click)="color('1')">
                                    Features of PayG</span>

                            </div>
                        </div>
                    </a>
                </div>
           

              


            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8" style="width:70%">
                <a [routerLink]="['/pay-g']"> <button class="btn btn-color" > <img
                            src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;PayG
                    </button></a>

            </div>
            <div class="col-md-4        " style="width:30%">
                <a [routerLink]="['/payment-gateway']"> <button class="btn btn-color"
                        (click)="menues('Web Integration')">Payment Gateway
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>

            </div>
        </div>
    </div>
</div>